import { AccountCompletion } from "./routes/AccountCompletion.tsx";
import { Callback } from "./routes/Callback.tsx";
import { Consent } from "./routes/Consent.tsx";
import { Login } from "./routes/Login.tsx";
import { Logout } from "./routes/Logout.tsx";

/**
 * Explicit pathname → identity route mapping.
 * Unknown paths fall through to Login (no second routing system).
 */
export function resolveAuthRoute(pathname: string) {
  if (pathname === "/auth/callback") return "callback" as const;
  if (pathname === "/auth/complete") return "complete" as const;
  if (pathname === "/oauth/consent") return "consent" as const;
  if (pathname === "/logout") return "logout" as const;
  return "login" as const;
}

export function App() {
  const route = resolveAuthRoute(window.location.pathname);
  switch (route) {
    case "callback":
      return <Callback />;
    case "complete":
      return <AccountCompletion />;
    case "consent":
      return <Consent />;
    case "logout":
      return <Logout />;
    default:
      return <Login />;
  }
}
